import { SVGProps } from 'react';

const TruckElectric = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14 19V7a2 2 0 0 0-2-2H9m6 14H9m6 0a2 2 0 0 0 4 0m-4 0a2 2 0 0 1 4 0M9 19a2 2 0 1 1-4 0m4 0a2 2 0 1 0-4 0m14 0h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62L18.3 9.38a1 1 0 0 0-.78-.38H14M2 13v5a1 1 0 0 0 1 1h2M4 3 2.15 5.15a.495.495 0 0 0 .35.86h2.15a.47.47 0 0 1 .35.86L3 9.02"
    />
  </svg>
);
export default TruckElectric;
